import { customElement, autoinject } from 'aurelia-framework';

@customElement('spinner')
@autoinject()
export class Spinner {}
